import { useState, useEffect } from "react";
import Cookies from "js-cookie";

export default function useAuth() {
  useEffect(() => {
    if (Cookies.get("name")) {
      login(Cookies.get("name"), Cookies.get("password"), Cookies.get("user_token"));
    }
  }, []);
  const [UserInfo, setUserInfo] = useState({ user_token: "", name: "", logged: false, password: null });
  function isLogged() {
    if (Cookies.get("user_token") !== undefined) {
      return true;
    }
    return false;
  }

  function login(userName, password, token) {
    setUserInfo({ user_token: token, name: userName, password: password, logged: true });
    Cookies.set("user_token", token);
    Cookies.set("name", userName);
    Cookies.set("password", password);
  }

  function logout() {
    setUserInfo({ user_token: null, name: null, password: null, logged: false });
    Cookies.remove("user_token");
    Cookies.remove("name");
    Cookies.remove("password");
    isLogged();
  }

  return { UserInfo, logout, login, isLogged };
}
